import { paletteVar, paletteVarAlpha } from "./palette-var";

/**
 * AG-Grid colour params wired to the MUI palette custom properties.
 *
 * AG-Grid isn't a MUI component, so it can't read `theme.palette`. Pointing its
 * colour params at the same `--ds-mui-palette-*` properties the rest of the app
 * uses makes every grid follow the active colour scheme: a theme without
 * `cssVariables` (prod, flag off) resolves each fallback — the grid's current
 * Quartz-light shade — so nothing changes, and the Kaizen theme resolves the
 * token, so grids go dark with everything else.
 *
 * Derived colours (hover, selection) use `paletteVarAlpha` so AG-Grid receives a
 * finished `color-mix` rather than trying to alpha-composite a `var()` itself —
 * the same reason MUI's `alpha()` can't take a custom property.
 *
 * Fallbacks are the current Quartz light defaults, so the base theme renders
 * identically.
 */
export const dataGridColorParams = {
  backgroundColor: paletteVar("background-paper", "#ffffff"),
  foregroundColor: paletteVar("text-primary", "#181d1f"),
  headerBackgroundColor: paletteVar("background-default", "#fafafa"),
  headerTextColor: paletteVar("text-secondary", "#181d1f"),
  // Quartz derives its border from the foreground at 15% alpha, not a solid grey;
  // the fallback reproduces that so the base grid keeps the same translucent line.
  borderColor: paletteVar("divider", "rgba(24, 29, 31, 0.15)"),
  // Hover and selection follow the brand purple under the Kaizen theme; the
  // fallbacks are Quartz's accent-blue tints (8% / 12%) so the base grid is
  // unchanged.
  rowHoverColor: paletteVarAlpha(paletteVar("primary-main", "#2196f3"), 0.08),
  selectedRowBackgroundColor: paletteVarAlpha(
    paletteVar("primary-main", "#2196f3"),
    0.12,
  ),
} as const;
